/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Информация о вложении
 */
export interface AttachmentRequest {
  /** Имя файла */
  fileName?: string;

  /** Содержимое файла с кодировкой в формате base64 */
  encodedString?: string;

  /** Категория файла */
  category?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;
}

/**
 * Редактирование СдПнУ
 */
export interface ContractRegUpdateRequest {
  /** Тип договора */
  docType?: string;

  /**
   * Идентификатор вида постановки договора на учёт
   * @format int32
   */
  docKind?: number;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date-time
   */
  prevDocDate?: string;

  /**
   * Дата снятия с учета
   * @format date-time
   */
  prevNumCloseDate?: string;

  /** Регистрационный номер предыдущего банка */
  prevNum?: string;

  /** УНК ранее присвоенный */
  contractDocNum?: string;

  /** Нерезиденты */
  nonresident?: NonresidentRequest[];

  /** Признак 'Договор без номера' */
  isWithoutNumber?: boolean;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата
   * @format date-time
   */
  contractSignDate?: string;

  /**
   * Дата завершения обязательств
   * @format date-time
   */
  contractCloseDate?: string;

  /** Признак 'Без суммы' */
  isUndefinedSum?: boolean;

  /** Сумма */
  contractSum?: number;

  /**
   * Идентификатор валюты
   * @format uuid
   */
  contractCurrencyId?: string;

  /** Код валюты */
  contractCurrencyCode?: string;

  /** Погашение за счет валютной выручки */
  currEarnRepay?: number;

  /**
   * Ожидаемый срок репатриации
   * @format date-time
   */
  expectedDate?: string;

  /** Сумма зачисления на счета за рубежом */
  abroadAccountSum?: number;

  /**
   * Код срока привлечения
   * @format uuid
   */
  repayPeriodCode?: string;

  /** Задолженность на предыдущую дату */
  debtSum?: number;

  /** Вид предоставляемых данных по графику платежей */
  contractInfo?: string;

  /** Список траншей */
  tranches?: TrancheRequest[];

  /** График платежей */
  schedules?: ScheduleRequest[];

  /** Вложения к документу */
  attachments?: AttachmentRequest[];

  /** Признак, что на данный момент договор не находится на учете в другом банке */
  isNotRegisteredForeign?: boolean;

  /** Признак срочной постановки на учет */
  isUrgent?: boolean;

  /** КПП клиента */
  clientKpp?: string;

  /**
   * Код основания для постановки на учет
   * @format uuid
   */
  basisCode?: string;

  /** Регистрационный номер уполномоченного банка/филиала уполномоченного банка */
  authorizedBankNum?: string;

  /** Уникальный номер контракта, присвоенного ранее (Возможно несколько значений) */
  earlyUnk?: string[];

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Информация об нерезиденте
 */
export interface NonresidentRequest {
  /**
   * Идентификатор нерезидента из МС Контрагенты
   * @format uuid
   */
  id?: string;

  /** Название нерезидента */
  name?: string;

  /**
   * Идентификатор страны нерезидента
   * @format uuid
   */
  countryId?: string;

  /** Код страны нерезидента */
  countryCode?: string;

  /** Код организации нерезидента */
  orgCode?: string;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;
}

/**
 * Информация о графике платежей
 */
export interface ScheduleRequest {
  /**
   * Дата платежа погашения основного долга
   * @format date-time
   */
  princPaymDate?: string;

  /** Сумма погашения основного долга */
  princPaymSum?: number;

  /**
   * Дата платежа погашения процентов
   * @format date-time
   */
  ratePaymDate?: string;

  /** Сумма погашения процентов */
  ratePaymSum?: number;

  /** Особые условия */
  specConditions?: string;

  /**
   * Порядковый номер платежа
   * @format int32
   */
  docNum?: number;
}

/**
 * Информация о транше
 */
export interface TrancheRequest {
  /**
   * Порядковый номер транша
   * @format int32
   */
  docNum?: number;

  /** Сумма транша */
  sum?: number;

  /**
   * Дата поступления
   * @format date-time
   */
  date?: string;

  /**
   * Код срока привлечения
   * @format uuid
   */
  repayPeriodCode?: string;
}

/**
 * Данные сохраненного документа
 */
export interface DocumentSaveResponse {
  /** @format uuid */
  documentId: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация об адресе
 */
export interface AddressRequest {
  /** Субъект РФ */
  region?: string;

  /** Район */
  area?: string;

  /** Город */
  city?: string;

  /** Населенный пункт */
  locality?: string;

  /** Улица (проспект, переулок и т.д.) */
  street?: string;

  /** Номер дома (владение) */
  house?: string;

  /** Корпус (строение) */
  struct?: string;

  /** Офис (квартира) */
  flat?: string;
}

/**
 * Информация для снятия с учета
 */
export interface CloseInfoRequest {
  /**
   * Идентификатор Договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** УНК договора */
  unk?: string;

  /**
   * Идентификатор основания для снятия с учета
   * @format uuid
   */
  reasonId?: string;

  /** Примечание к основанию снятия с учёта */
  comment?: string;

  /** Информация о новом резиденте */
  newClient?: NewClientRequest;

  /** Признак лица, которому переходят права (требования) (на которое переводится долг) */
  assigneeSign?: string;

  /** Код страны государственной регистрации (места нахождения) нерезидента */
  nonresidentCountryCode?: string;
}

/**
 * Редактирование ЗоСсУ
 */
export interface ContractCloseUpdateRequest {
  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Уникальные номера и основания для снятия с учета */
  closeInfoList?: CloseInfoRequest[];

  /** Примечание к документу ЗоСсУ */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Вложения к документу ЗоСсУ */
  attachments?: AttachmentRequest[];

  /** КПП клиента */
  clientKpp?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Информация о новом резиденте
 */
export interface NewClientRequest {
  /** Новое наименование резидента */
  name?: string;

  /**
   * Код из кодификатора 'Организационно-правовая форма лица'
   * @format int64
   */
  legalEntity?: number;

  /** ОГРН */
  ogrn?: string;

  /**
   * Дата внесения записи в госреестр
   * @format date-time
   */
  registerDate?: string;

  /** ИНН */
  inn?: string;

  /** КПП */
  kpp?: string;

  /** Признак отсутствия номера контракта/ кредитного договора */
  isWithoutNumber?: boolean;

  /** Номер документа, подтверждающего уступку требования и перевод долга по контракту */
  docNum?: string;

  /**
   * Дата документа, подтверждающего уступку требования и перевод долга по контракту
   * @format date-time
   */
  docDate?: string;

  /** Информация об адресе */
  newAddress?: AddressRequest;
}

/**
 * Уникальные номера и основания для снятия с учета
 */
export interface ChangeInfoRequest {
  /** УНК договора */
  unk?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Идентификатор Договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** Список изменений в сведениях о договоре */
  contractList?: NewContractInfoRequest[];

  /** Список документов-оснований */
  reasonList?: ChangeReasonRequest[];
}

/**
 * Список документов-оснований
 */
export interface ChangeReasonRequest {
  /** Вид документа-основания */
  kind?: string;

  /** Номер документа-основания */
  number?: string;

  /** Признак отсутствия номера */
  isWithoutNumber?: boolean;

  /** Примечание */
  note?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Дата документа-основания
   * @format date-time
   */
  date?: string;
}

/**
 * Изменения в сведениях резидента
 */
export interface ClientChangeInfoRequest {
  /** Новое наименование резидента */
  newClientName?: string;

  /** Новый ОГРН резидента */
  newClientOgrn?: string;

  /**
   * Новая дата регистрации резидента
   * @format date-time
   */
  newClientRegDate?: string;

  /** Новый ИНН резидента */
  newClientInn?: string;

  /** Новый КПП резидента */
  newClientKpp?: string;
}

/**
 * Редактирование Зови
 */
export interface ContractChangeUpdateRequest {
  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Примечание к документу ЗоВИ */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Тип изменений */
  typeChange?: string;

  /** КПП клиента */
  clientKpp?: string;

  /** Вложения к документу ЗоВИ */
  attachments?: AttachmentRequest[];

  /** Уникальные номера и основания для снятия с учета */
  changeInfoList?: ChangeInfoRequest[];

  /** Изменения в сведениях резидента */
  client?: ClientChangeInfoRequest;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Список изменений в сведениях о договоре
 */
export interface NewContractInfoRequest {
  /** Номер пункта, в который вносится изменение */
  item?: string;

  /** Номер графы, в которую вносится изменение */
  column?: string;

  /** Строковое значение выполняемого изменения */
  newData?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;
}

/**
 * Информация о вложении
 */
export interface AttachmentUploadResponse {
  /** Состояние заливки файла */
  ready?: boolean;

  /** Код ошибки заливки файла */
  errorCode?: string;

  /** Описание ошибки заливки файла */
  errorDescription?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  documentId?: string;

  /**
   * Идентификатор файла
   * @format uuid
   */
  extId?: string;

  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /** Категория файла */
  category?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;
}

/**
 * Информация о подписанном документе
 */
export interface DocumentSendResponse {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Вид документа ВК */
  type?: string;

  /** Номер документа */
  number?: string;

  /** Статус документа */
  state?: string;
}

/**
 * Создание СдПнУ
 */
export interface ContractRegCreateRequest {
  /** Тип договора */
  docType?: string;

  /**
   * Идентификатор вида постановки договора на учёт
   * @format int32
   */
  docKind?: number;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date-time
   */
  prevDocDate?: string;

  /**
   * Дата снятия с учета
   * @format date-time
   */
  prevNumCloseDate?: string;

  /** Регистрационный номер предыдущего банка */
  prevNum?: string;

  /** УНК ранее присвоенный */
  contractDocNum?: string;

  /** Нерезиденты */
  nonresident?: NonresidentRequest[];

  /** Признак 'Договор без номера' */
  isWithoutNumber?: boolean;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата
   * @format date-time
   */
  contractSignDate?: string;

  /**
   * Дата завершения обязательств
   * @format date-time
   */
  contractCloseDate?: string;

  /** Признак 'Без суммы' */
  isUndefinedSum?: boolean;

  /** Сумма */
  contractSum?: number;

  /**
   * Идентификатор валюты
   * @format uuid
   */
  contractCurrencyId?: string;

  /** Код валюты */
  contractCurrencyCode?: string;

  /** Погашение за счет валютной выручки */
  currEarnRepay?: number;

  /**
   * Ожидаемый срок репатриации
   * @format date-time
   */
  expectedDate?: string;

  /** Сумма зачисления на счета за рубежом */
  abroadAccountSum?: number;

  /**
   * Код срока привлечения
   * @format uuid
   */
  repayPeriodCode?: string;

  /** Задолженность на предыдущую дату */
  debtSum?: number;

  /** Вид предоставляемых данных по графику платежей */
  contractInfo?: string;

  /** Список траншей */
  tranches?: TrancheRequest[];

  /** График платежей */
  schedules?: ScheduleRequest[];

  /** Вложения к документу */
  attachments?: AttachmentRequest[];

  /** Признак, что на данный момент договор не находится на учете в другом банке */
  isNotRegisteredForeign?: boolean;

  /** Признак срочной постановки на учет */
  isUrgent?: boolean;

  /** КПП клиента */
  clientKpp?: string;

  /**
   * Код основания для постановки на учет
   * @format uuid
   */
  basisCode?: string;

  /** Регистрационный номер уполномоченного банка/филиала уполномоченного банка */
  authorizedBankNum?: string;

  /** Уникальный номер контракта, присвоенного ранее (Возможно несколько значений) */
  earlyUnk?: string[];

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentUploadRequest {
  /** Имя файла */
  fileName?: string;

  /** Содержимое файла с кодировкой в формате base64 */
  encodedString?: string;

  /** Категория файла */
  category?: string;
}

/**
 * Создание ЗоСсУ
 */
export interface ContractCloseCreateRequest {
  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Уникальные номера и основания для снятия с учета */
  closeInfoList?: CloseInfoRequest[];

  /** Примечание к документу ЗоСсУ */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Вложения к документу ЗоСсУ */
  attachments?: AttachmentRequest[];

  /** КПП клиента */
  clientKpp?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Создание ЗоВИ
 */
export interface ContractChangeCreateRequest {
  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Примечание к документу ЗоВИ */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Тип изменений */
  typeChange?: string;

  /** КПП клиента */
  clientKpp?: string;

  /** Вложения к документу ЗоВИ */
  attachments?: AttachmentRequest[];

  /** Уникальные номера и основания для снятия с учета */
  changeInfoList?: ChangeInfoRequest[];

  /** Изменения в сведениях резидента */
  client?: ClientChangeInfoRequest;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Получение СдПнУ
 */
export interface ContractRegListResponse {
  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество документов СдПнУ
   * @format int32
   */
  statementAmount?: number;

  /**
   * Количество документов СдПнУ в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /** Список документов СдПнУ */
  statements?: ContractRegResponse[];
}

/**
 * Получение СдПнУ
 */
export interface ContractRegResponse {
  /**
   * Внешний идентификатор документа СдПнУ
   * @format uuid
   */
  id?: string;

  /** Система-источник документа */
  sourceSystem?: string;

  /** Номер документа СдПнУ */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   * @example 2022-05-05
   */
  documentDate?: string;

  /** Статус выполнения документа */
  state?: string;

  /** Тип контракта */
  docType?: string;

  /**
   * Вид постановки договора на учёт
   * @format int32
   */
  docKind?: number;

  /**
   * Дата подписания договора
   * @format date
   */
  contractSignDate?: string;

  /**
   * Дата завершения обязательств по договору
   * @format date
   */
  contractCloseDate?: string;

  /** Номер договора */
  contractNumber?: string;

  /** Признак "Без номера договора" */
  isWithoutNumber?: boolean;

  /**
   * Сумма договора
   * @format double
   */
  contractSum?: number;

  /** Признак "Договор без суммы" */
  isUndefinedSum?: boolean;

  /** Буквенный код валюты ISO */
  contractCurrCode?: string;

  /** УНК присвоенный Банком, ушедший в ТБС ВК */
  unk?: string;

  /** Признак наличия досыла */
  isAddfilesending?: boolean;

  /**
   * Идентификатор документа Отзыв, созданного к данному документу
   * @format uuid
   */
  revokeId?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Список разрешений для документа СдПнУ */
  permissions?: PermissionResponse[];

  /** УНК присвоенный ранее */
  previousUnk?: string;

  /**
   * Количество нерезидентов
   * @format int32
   */
  nonresidentAmount?: number;

  /** Список нерезидентов */
  nonresident?: NonResidentRegListResponse[];

  /** Признак наличия вложений у документа */
  isAttachment?: boolean;
}

/**
 * Информация о нерезиденте
 */
export interface NonResidentRegListResponse {
  /** Наименование нерезидента */
  name?: string;
}

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Информация о вложении
 */
export interface AttachmentResponse {
  /** Состояние заливки файла */
  ready?: boolean;

  /** Код ошибки заливки файла */
  errorCode?: string;

  /** Описание ошибки заливки файла */
  errorDescription?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  documentId?: string;

  /**
   * Идентификатор файла
   * @format uuid
   */
  extId?: string;

  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /** Категория файла */
  category?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;
}

/**
 * Получение детальной информации документа СдПнУ
 */
export interface ContractRegDetailResponse {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Статус документа */
  state?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Статус отправки ВБК по данному документу */
  vbkState?: string;

  /** Тип документа */
  docType?: string;

  /**
   * Вид постановки договора на учёт
   * @format int32
   */
  docKind?: number;

  /** ОГРН */
  clientOgrn?: string;

  /**
   * Дата внесения записи в государственный реестр
   * @format date-time
   */
  clientRegisterDate?: string;

  /** УНК присвоенный Банком, ушедший в ТБС ВК */
  bankDocNumber?: string;

  /**
   * Дата регистрации УНК Банка
   * @format date
   */
  bankRegDate?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date-time
   */
  prevDocDate?: string;

  /**
   * Дата снятия с учета
   * @format date-time
   */
  prevNumCloseDate?: string;

  /** Регистрационный номер предыдущего банка */
  prevNum?: string;

  /** УНК ранее присвоенный */
  contractDocNum?: string;

  /** Признак 'Договор без номера' */
  isWithoutNumber?: boolean;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата
   * @format date-time
   */
  contractSignDate?: string;

  /**
   * Дата завершения обязательств
   * @format date-time
   */
  contractCloseDate?: string;

  /** Признак 'Без суммы' */
  isUndefinedSum?: boolean;

  /** Сумма */
  contractSum?: number;

  /** Погашение за счет валютной выручки */
  currEarnRepay?: number;

  /**
   * Ожидаемый срок репатриации
   * @format date-time
   */
  expectedDate?: string;

  /** Сумма зачисления на счета за рубежом */
  abroadAccountSum?: number;

  /**
   * Код срока привлечения
   * @format int32
   */
  repayPeriodCode?: number;

  /** Задолженность на предыдущую дату */
  debtSum?: number;

  /** Вид предоставляемых данных по графику платежей */
  contractInfo?: string;

  /** Признак, что на данный момент договор не находится на учете в другом банке */
  isNotRegisteredForeign?: boolean;

  /** Признак срочной постановки на учет */
  isUrgent?: boolean;

  /** Нерезиденты */
  nonresident?: NonresidentResponse[];

  /** Валюта договора */
  contractCurrency?: CurrencyResponse;

  /** Пояснение к Виду предоставляемых данных по графику платежей */
  contractInfoDesc?: string;

  /** Список траншей */
  tranches?: TrancheResponse[];

  /** График платежей */
  schedules?: ScheduleRequest[];

  /** Вложения к документу */
  attachments?: AttachmentResponse[];

  /** Причина отказа по договору */
  reject?: RejectResponse;

  /** Привилегии на документ */
  permissions?: PermissionResponse[];

  /** Признак, что у документа есть досыл */
  isAddFileSending?: boolean;

  /**
   * Идентификатор документа Отзыв, созданного к данному документу
   * @format uuid
   */
  revokeId?: string;

  /**
   * Id кода основания для постановки на учет
   * @format uuid
   */
  basisCode?: string;

  /** Код основания для постановки на учет */
  basisCodeValue?: string;

  /** Описание основания для постановки на учет */
  basisDescription?: string;

  /** Регистрационный номер уполномоченного банка/филиала уполномоченного банка */
  authorizedBankNum?: string;

  /** Уникальный номер контракта, присвоенного ранее (Возможно несколько значений) */
  earlyUnk?: string[];

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Страна нерезидента
 */
export interface CountryResponse {
  /**
   * Идентификатор страны нерезидента
   * @format uuid
   */
  id?: string;

  /** Код страны нерезидента */
  codeIso?: string;

  /** Наименование страны нерезидента */
  shortName?: string;

  /** Наименование страны нерезидента */
  fullName?: string;

  /** Английское наименование страны нерезидента */
  englishName?: string;

  /** 2-х буквенный код страны */
  charCode2?: string;

  /** 3-х буквенный код страны */
  charCode3?: string;
}

/**
 * Валюта договора
 */
export interface CurrencyResponse {
  /**
   * Идентификатор валюты
   * @format uuid
   */
  id?: string;

  /** Наименование валюты */
  name?: string;

  /** Код валюты */
  alphabeticCode?: string;

  /** Цифровой код валюты */
  numericCode?: string;

  /** Наименование валюты ОКВ */
  okvName?: string;

  /** Признак активности валюты */
  isActive?: boolean;

  /** Символ валюты */
  symbol?: string;
}

/**
 * Нерезидент
 */
export interface NonresidentResponse {
  /**
   * Идентификатор нерезидента из МС Контрагенты
   * @format uuid
   */
  id?: string;

  /** Название нерезидента */
  name?: string;

  /** Страна нерезидента */
  country?: CountryResponse;

  /** Код организации нерезидента */
  orgCode?: string;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;
}

/**
 * Причина отказа по договору
 */
export interface RejectResponse {
  /**
   * Идентификатор причины отказа
   * @format uuid
   */
  rejectReasonId?: string;

  /** Наименование причины отказа по договору */
  rejectReasonName?: string;

  /** Комментарий к причине отказа */
  comment?: string;
}

/**
 * Транш
 */
export interface TrancheResponse {
  /**
   * Порядковый номер транша
   * @format int32
   */
  docNum?: number;

  /**
   * Код срока привлечения
   * @format int32
   */
  repayPeriodCode?: number;

  /** Код срока привлечения */
  repayPeriodCodeName?: string;

  /** Сумма транша */
  sum?: number;

  /**
   * Ожидаемая дата поступления транша
   * @format date-time
   */
  date?: string;
}

/**
 * Код срока привлечения
 */
export interface TermCodeResponse {
  /**
   * Идентификатор кода срока привлечения
   * @format uuid
   */
  id: string;

  /**
   * Код срока привлечения
   * @format int32
   */
  code: number;

  /** Наименование основания */
  desc: string;
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: PermissionResponse[];
}

/**
 * Список документов
 */
export interface DocumentListResponse {
  /**
   * Идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Список документов истории изменений договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** Список документов */
  document?: DocumentResponse[];
}

/**
 * Информация о документе
 */
export interface DocumentResponse {
  /** Тип документа */
  type?: string;

  /** Имя документа */
  name?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Статус документа */
  state?: string;

  /** Номер документа */
  number?: string;

  /**
   * Дата создания документа
   * @format date-time
   */
  date?: string;
}

/**
 * Информация об адресе
 */
export interface AddressResponse {
  /** Субъект РФ */
  region?: string;

  /** Район */
  area?: string;

  /** Город */
  city?: string;

  /** Населенный пункт */
  locality?: string;

  /** Улица (проспект, переулок и т.д.) */
  street?: string;

  /** Номер дома (владение) */
  house?: string;

  /** Корпус (строение) */
  struct?: string;

  /** Офис (квартира) */
  flat?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentCcb {
  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;
}

/**
 * Список корректировок
 */
export interface ChangeInfoCcb {
  /** УНК договора */
  unk?: string;

  /** Список изменений в сведениях о договоре */
  contractList?: NewContractInfoRequest[];

  /** Список документов-оснований */
  reasonList?: ChangeReasonRequest[];

  /** Причина отказа по договору */
  reject?: RejectCcb;
}

/**
 * Информация для снятия с учета
 */
export interface CloseInfoCcb {
  /** УНК договора */
  unk?: string;

  /** Причина отказа по договору */
  reject?: RejectCcb;

  /** Примечание к основанию снятия с учёта */
  comment?: string;

  /** Основание для снятия с учёта */
  closeReason?: CloseReasonCcb;

  /** Информация о новом резиденте */
  newClient?: NewClientResponse;

  /** Признак лица, которому переходят права (требования) (на которое переводится долг) */
  assigneeSign?: string;

  /** Код страны государственной регистрации (места нахождения) нерезидента */
  nonresidentCountryCode?: string;
}

/**
 * Основание для снятия с учёта
 */
export interface CloseReasonCcb {
  /** Наименование основания */
  name?: string;
}

/**
 * Получение ЗоВи
 */
export interface ContractChangeCcb {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Примечание к документу */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Вложения к документу ЗоВИ */
  attachments?: AttachmentCcb[];

  /** Уникальные номера и основания для снятия с учета */
  changeInfoList?: ChangeInfoCcb[];

  /** Изменения в сведениях резидента */
  client?: ClientChangeInfoRequest;

  /**
   * Дата представления резидентом документа
   * @format date-time
   */
  receiveDate?: string;

  /**
   * Дата завершения обработки документа
   * @format date-time
   */
  executeDate?: string;

  /** ФИО сотрудника обрабатывающего документ */
  employeeName?: string;

  /** Тип изменений */
  typeChange?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Получение ЗосСу
 */
export interface ContractCloseCcb {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Примечание к документу */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Уникальные номера и основания для снятия с учета */
  closeInfoList?: CloseInfoCcb[];

  /** Вложения к документу ЗоСсУ */
  attachments?: AttachmentCcb[];

  /**
   * Дата представления резидентом документа
   * @format date-time
   */
  receiveDate?: string;

  /**
   * Дата завершения обработки документа
   * @format date-time
   */
  executeDate?: string;

  /** ФИО сотрудника обрабатывающего документ */
  employeeName?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Получение СдПнУ
 */
export interface ContractRegCcb {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Тип документа */
  docType?: string;

  /**
   * Вид постановки договора на учёт
   * @format int32
   */
  docKind?: number;

  /** ОГРН */
  clientOgrn?: string;

  /**
   * Дата внесения записи в государственный реестр
   * @format date-time
   */
  clientRegisterDate?: string;

  /** УНК присвоенный Банком, ушедший в ТБС ВК */
  bankDocNumber?: string;

  /**
   * Дата регистрации УНК Банка
   * @format date
   */
  bankRegDate?: string;

  /** УНК из предыдущего банка */
  strDocNumber?: string;

  /**
   * Дата постановки на учет
   * @format date-time
   */
  prevDocDate?: string;

  /**
   * Дата снятия с учета
   * @format date-time
   */
  prevNumCloseDate?: string;

  /** Регистрационный номер предыдущего банка */
  prevNum?: string;

  /** УНК ранее присвоенный */
  contractDocNum?: string;

  /** Признак 'Договор без номера' */
  isWithoutNumber?: boolean;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата
   * @format date-time
   */
  contractSignDate?: string;

  /**
   * Дата завершения обязательств
   * @format date-time
   */
  contractCloseDate?: string;

  /** Признак 'Без суммы' */
  isUndefinedSum?: boolean;

  /** Сумма */
  contractSum?: number;

  /** Погашение за счет валютной выручки */
  currEarnRepay?: number;

  /**
   * Ожидаемый срок репатриации
   * @format date-time
   */
  expectedDate?: string;

  /** Сумма зачисления на счета за рубежом */
  abroadAccountSum?: number;

  /**
   * Код срока привлечения
   * @format int32
   */
  repayPeriodCode?: number;

  /** Задолженность на предыдущую дату */
  debtSum?: number;

  /** Вид предоставляемых данных по графику платежей */
  contractInfo?: string;

  /** Признак, что на данный момент договор не находится на учете в другом банке */
  isNotRegisteredForeign?: boolean;

  /** Признак срочной постановки на учет */
  isUrgent?: boolean;

  /** Нерезиденты */
  nonresident?: NonresidentCcb[];

  /** Код валюты договора */
  contractCurrencyCode?: string;

  /** Список траншей */
  tranches?: TrancheResponse[];

  /** График платежей */
  schedules?: ScheduleRequest[];

  /** Вложения к документу */
  attachments?: AttachmentCcb[];

  /** Причина отказа по договору */
  reject?: RejectCcb;

  /**
   * Дата представления резидентом документа
   * @format date-time
   */
  receiveDate?: string;

  /**
   * Дата завершения обработки документа
   * @format date-time
   */
  executeDate?: string;

  /** ФИО сотрудника обрабатывающего документ */
  employeeName?: string;

  /** Регистрационный номер уполномоченного банка/филиала уполномоченного банка */
  authorizedBankNum?: string;

  /**
   * Код основания для постановки на учет
   * @format uuid
   */
  basisCode?: string;

  /** Код основания для постановки на учет */
  earlyUnk?: string[];

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields =
  | ContractCloseCcb
  | ContractChangeCcb
  | ContractRegCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Информация о новом резиденте
 */
export interface NewClientResponse {
  /** Новое наименование резидента */
  name?: string;

  /**
   * Код из кодификатора 'Организационно-правовая форма лица'
   * @format int64
   */
  legalEntity?: number;

  /** ОГРН */
  ogrn?: string;

  /**
   * Дата внесения записи в госреестр
   * @format date-time
   */
  registerDate?: string;

  /** ИНН */
  inn?: string;

  /** КПП */
  kpp?: string;

  /** Признак отсутствия номера контракта/ кредитного договора */
  isWithoutNumber?: boolean;

  /** Номер документа, подтверждающего уступку требования и перевод долга по контракту */
  docNum?: string;

  /**
   * Дата документа, подтверждающего уступку требования и перевод долга по контракту
   * @format date-time
   */
  docDate?: string;

  /** Информация об адресе */
  newAddress?: AddressResponse;
}

/**
 * Нерезидент
 */
export interface NonresidentCcb {
  /** Название нерезидента */
  name?: string;

  /** Код страны нерезидента */
  countryCode?: string;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * Причина отказа по договору
 */
export interface RejectCcb {
  /** Наименование причины отказа по договору */
  rejectReasonName?: string;

  /** Комментарий к причине отказа */
  comment?: string;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Информация для снятия с учета
 */
export interface CloseInfoListRequest {
  /** УНК договора */
  unk?: string;

  /**
   * Идентификатор Договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** Основание для снятия с учёта */
  closeReason?: CloseReasonResponse;

  /** Примечание к основанию снятия с учёта */
  comment?: string;

  /** Признак лица, которому переходят права (требования) (на которое переводится долг) */
  assigneeSign?: string;

  /** Код страны государственной регистрации (места нахождения) нерезидента */
  nonresidentCountryCode?: string;
}

/**
 * Основание для снятия с учёта
 */
export interface CloseReasonResponse {
  /**
   * Идентификатор основания
   * @format uuid
   */
  id?: string;

  /** Наименование основания */
  name?: string;
}

/**
 * Получение ЗосСу
 */
export interface ContractCloseListResponse {
  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество документов ЗоСсУ
   * @format int32
   */
  statementAmount?: number;

  /**
   * Количество документов ЗоСсУ в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /** Список документов ЗоСсУ */
  statements?: ContractCloseResponse[];
}

/**
 * Получение ЗосСу
 */
export interface ContractCloseResponse {
  /**
   * Внешний идентификатор документа ЗоСсУ
   * @format uuid
   */
  id?: string;

  /** Система-источник документа */
  sourceSystem?: string;

  /** Номер документа ЗоСсУ */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   * @example 2022-05-05
   */
  documentDate?: string;

  /** Статус выполнения документа */
  state?: string;

  /** Список оснований для снятия с учета */
  closeInfoList?: CloseInfoListRequest[];

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Признак наличия досыла */
  isAddfilesending?: boolean;

  /**
   * Идентификатор документа Отзыв, созданного к данному документу
   * @format uuid
   */
  revokeId?: string;

  /** Список разрешений для документа ЗоСсу */
  permissions?: PermissionResponse[];

  /** Признак наличия вложений у документа */
  isAttachment?: boolean;
}

/**
 * Информация для снятия с учета
 */
export interface CloseInfoResponse {
  /** УНК договора */
  unk?: string;

  /**
   * Идентификатор договора
   * @format uuid
   */
  agreementId?: string;

  /** Основание для снятия с учёта */
  closeReason?: CloseReasonResponse;

  /** Примечание к основанию снятия с учёта */
  comment?: string;

  /** Информация о новом резиденте */
  newClient?: NewClientResponse;

  /** Причина отказа по договору */
  reject?: RejectResponse;

  /** Признак лица, которому переходят права (требования) (на которое переводится долг) */
  assigneeSign?: string;

  /** Код страны государственной регистрации (места нахождения) нерезидента */
  nonresidentCountryCode?: string;

  /** Страна нерезидента */
  nonresidentCountry?: CountryResponse;
}

/**
 * Получение деталей документа
 */
export interface ContractCloseDetailResponse {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Статус документа */
  state?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Примечание к документу */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Уникальные номера и основания для снятия с учета */
  closeInfoList?: CloseInfoResponse[];

  /** Вложения к документу ЗоСсУ */
  attachments?: AttachmentResponse[];

  /** Привилегии на документ ЗоСсУ */
  permissions?: PermissionResponse[];

  /** Признак, что у документа есть досыл */
  isAddFileSending?: boolean;

  /**
   * Идентификатор договора отзыва
   * @format uuid
   */
  revokeId?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Уникальные номера и основания для снятия с учета
 */
export interface ChangeInfoListResponse {
  /** УНК договора */
  unk?: string;

  /**
   * Идентификатор Договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** Список изменений в сведениях о договоре */
  contractList?: NewContractInfoRequest[];

  /** Список документов-оснований */
  reasonList?: ChangeReasonListResponse[];

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;
}

/**
 * Список документов-оснований
 */
export interface ChangeReasonListResponse {
  /** Вид документа-основания */
  kind?: string;

  /** Номер документа-основания */
  number?: string;

  /** Признак отсутствия номера */
  isWithoutNumber?: boolean;

  /** Примечание */
  note?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Дата документа-основания
   * @format date
   */
  date?: string;
}

/**
 * Получение списка ЗоВИ
 */
export interface ContractChangeListResponse {
  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество документов ЗоВИ
   * @format int32
   */
  statementAmount?: number;

  /**
   * Количество документов ЗоВИ в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /** Список документов ЗоВИ */
  statements?: ContractChangeResponse[];
}

/**
 * Получение ЗоВИ
 */
export interface ContractChangeResponse {
  /**
   * Внешний идентификатор документа ЗоВИ
   * @format uuid
   */
  id?: string;

  /** Система-источник документа */
  sourceSystem?: string;

  /** Номер документа ЗоВИ */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   * @example 2022-05-05
   */
  documentDate?: string;

  /** Статус выполнения документа */
  state?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Признак наличия досыла */
  isAddfilesending?: boolean;

  /**
   * Идентификатор документа Отзыв, созданного к данному документу
   * @format uuid
   */
  revokeId?: string;

  /** Список разрешений для документа ЗоВИ */
  permissions?: PermissionResponse[];

  /** Тип изменений */
  typeChange?: string;

  /** Список корректировок */
  changeInfoList?: ChangeInfoListResponse[];

  /** Изменения в сведениях резидента */
  client?: ClientChangeInfoRequest;

  /** Признак наличия вложений у документа */
  isAttachment?: boolean;
}

/**
 * Список корректировок
 */
export interface ChangeInfoResponse {
  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Идентификатор Договора ВЭД
   * @format uuid
   */
  agreementId?: string;

  /** УНК договора */
  unk?: string;

  /** Список изменений в сведениях о договоре */
  contractList?: NewContractInfoResponse[];

  /** Список документов-оснований */
  reasonList?: ChangeReasonResponse[];

  /** Причина отказа по договору */
  reject?: RejectResponse;
}

/**
 * Список документов-оснований
 */
export interface ChangeReasonResponse {
  /** Вид документа-основания */
  kind?: string;

  /** Номер документа-основания */
  number?: string;

  /** Признак отсутствия номера */
  isWithoutNumber?: boolean;

  /** Примечание */
  note?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Дата документа-основания
   * @format date-time
   */
  date?: string;

  /**
   * Идентификатор документа-основания
   * @format uuid
   */
  id?: string;
}

/**
 * Изменения в сведениях резидента
 */
export interface ClientChangeInfoResponse {
  /** Новое наименование резидента */
  newClientName?: string;

  /** Новый ОГРН резидента */
  newClientOgrn?: string;

  /**
   * Новая дата регистрации резидента
   * @format date-time
   */
  newClientRegDate?: string;

  /** Новый ИНН резидента */
  newClientInn?: string;

  /** Новый КПП резидента */
  newClientKpp?: string;

  /**
   * Идентификатор изменения в сведениях резидента
   * @format uuid
   */
  id?: string;
}

/**
 * Получение детальной информации документа ЗоВИ
 */
export interface ContractChangeDetailResponse {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Статус документа */
  state?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка УК */
  authBankName?: string;

  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;

  /** Примечание к документу */
  note?: string;

  /** С тарифами Банка согласны */
  isAgreementTariff?: boolean;

  /** Вложения к документу ЗоВИ */
  attachments?: AttachmentResponse[];

  /** Уникальные номера и основания для снятия с учета */
  changeInfoList?: ChangeInfoResponse[];

  /** Изменения в сведениях резидента */
  client?: ClientChangeInfoResponse;

  /** Привилегии на документ */
  permissions?: PermissionResponse[];

  /** Тип изменений */
  typeChange?: string;

  /** Признак, что у документа есть досыл */
  isAddFileSending?: boolean;

  /**
   * Идентификатор договора отзыва
   * @format uuid
   */
  revokeId?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;
}

/**
 * Список изменений в сведениях о договоре
 */
export interface NewContractInfoResponse {
  /** Номер пункта, в который вносится изменение */
  item?: string;

  /** Номер графы, в которую вносится изменение */
  column?: string;

  /** Строковое значение выполняемого изменения */
  newData?: string;

  /**
   * Порядковый №
   * @format int32
   */
  recNumber?: number;

  /**
   * Идентификатор изменения в договоре
   * @format uuid
   */
  id?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Получение списка оснований постановки на учет
 */
export interface BasisCodesListResponse {
  /** Список оснований постановки на учет */
  codes?: BasisCodesResponse[];
}

/**
 * Основание для постановки на учет
 */
export interface BasisCodesResponse {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Код основания */
  code?: string;

  /** Описание */
  description?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис ms-currency-contract-management
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=105056884)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags СдПнУ
     * @name GetContractReg
     * @summary Получение детальной информации
     * @request GET:/api/contract/v1/external/reg/{id}
     * @secure
     */
    getContractReg: (id: string, params: RequestParams = {}) =>
      this.request<ContractRegDetailResponse, GenericError>({
        path: `/api/contract/v1/external/reg/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags СдПнУ
     * @name UpdateContractReg
     * @summary Редактирование
     * @request PUT:/api/contract/v1/external/reg/{id}
     * @secure
     */
    updateContractReg: (
      id: string,
      data: ContractRegUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/reg/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags СдПнУ
     * @name DeleteContractReg
     * @summary Удаление
     * @request DELETE:/api/contract/v1/external/reg/{id}
     * @secure
     */
    deleteContractReg: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/contract/v1/external/reg/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name GetContractClose
     * @summary Получение детальной информации
     * @request GET:/api/contract/v1/external/close/{id}
     * @secure
     */
    getContractClose: (id: string, params: RequestParams = {}) =>
      this.request<ContractCloseDetailResponse, GenericError>({
        path: `/api/contract/v1/external/close/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name UpdateContractClose
     * @summary Редактирование
     * @request PUT:/api/contract/v1/external/close/{id}
     * @secure
     */
    updateContractClose: (
      id: string,
      data: ContractCloseUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/close/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name DeleteContractClose
     * @summary Удаление
     * @request DELETE:/api/contract/v1/external/close/{id}
     * @secure
     */
    deleteContractClose: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/contract/v1/external/close/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоВИ
     * @name GetContractChange
     * @summary Получение детальной информации
     * @request GET:/api/contract/v1/external/change/{id}
     * @secure
     */
    getContractChange: (id: string, params: RequestParams = {}) =>
      this.request<ContractChangeDetailResponse, GenericError>({
        path: `/api/contract/v1/external/change/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоВИ
     * @name UpdateContractChange
     * @summary Редактирование
     * @request PUT:/api/contract/v1/external/change/{id}
     * @secure
     */
    updateContractChange: (
      id: string,
      data: ContractChangeUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/change/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоВИ
     * @name DeleteContractChange
     * @summary Удаление
     * @request DELETE:/api/contract/v1/external/change/{id}
     * @secure
     */
    deleteContractChange: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/contract/v1/external/change/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name UploadMultipartFile
     * @summary Загрузка файла Клиентом
     * @request POST:/api/contract/v2/external/files/upload/{documentType}
     * @secure
     */
    uploadMultipartFile: (
      documentType: string,
      data: { file: File },
      query?: { category?: string },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentUploadResponse, GenericError | void>({
        path: `/api/contract/v2/external/files/upload/${documentType}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name UpdateDocumentStatus
     * @summary Обновление статуса документа
     * @request POST:/api/contract/v1/external/update-status/{documentType}/{id}
     * @secure
     */
    updateDocumentStatus: (
      documentType: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/contract/v1/external/update-status/${documentType}/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name SendDocument
     * @summary Отправка подписанного документа в Банк
     * @request POST:/api/contract/v1/external/send/{documentType}/{id}
     * @secure
     */
    sendDocument: (
      documentType: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSendResponse, GenericError>({
        path: `/api/contract/v1/external/send/${documentType}/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags СдПнУ
     * @name GetListContractReg
     * @summary Получение списка СдПнУ
     * @request GET:/api/contract/v1/external/reg
     * @secure
     */
    getListContractReg: (
      query?: {
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        contract?: string;
        nonres?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractRegListResponse, GenericError>({
        path: `/api/contract/v1/external/reg`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags СдПнУ
     * @name CreateContractReg
     * @summary Создание
     * @request POST:/api/contract/v1/external/reg
     * @secure
     */
    createContractReg: (
      data: ContractRegCreateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/reg`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Upload
     * @summary Загрузка файла Клиентом
     * @request POST:/api/contract/v1/external/files/upload/{documentType}
     * @secure
     */
    upload: (
      documentType: string,
      data: AttachmentUploadRequest,
      params: RequestParams = {}
    ) =>
      this.request<AttachmentUploadResponse, GenericError | void>({
        path: `/api/contract/v1/external/files/upload/${documentType}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name GetListContractClose
     * @summary Получение списка ЗОСУ
     * @request GET:/api/contract/v1/external/close
     * @secure
     */
    getListContractClose: (
      query?: {
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        unk?: string;
        reasonId?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractCloseListResponse, GenericError>({
        path: `/api/contract/v1/external/close`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name CreateContractClose
     * @summary Создание
     * @request POST:/api/contract/v1/external/close
     * @secure
     */
    createContractClose: (
      data: ContractCloseCreateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/close`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоВИ
     * @name GetListContractChange
     * @summary Получение списка ЗОВИ
     * @request GET:/api/contract/v1/external/change
     * @secure
     */
    getListContractChange: (
      query?: {
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        unk?: string;
        searchString?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractChangeListResponse, GenericError>({
        path: `/api/contract/v1/external/change`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоВИ
     * @name CreateContractChange
     * @summary Создание
     * @request POST:/api/contract/v1/external/change
     * @secure
     */
    createContractChange: (
      data: ContractChangeCreateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/contract/v1/external/change`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags СдПнУ
     * @name GetRepayPeriodCode
     * @summary Получение справочника "Код срока привлечения"
     * @request GET:/api/contract/v1/external/reg/repay-period-code
     * @secure
     */
    getRepayPeriodCode: (params: RequestParams = {}) =>
      this.request<TermCodeResponse[], GenericError>({
        path: `/api/contract/v1/external/reg/repay-period-code`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Печать пдф
     * @name MakeClientReport
     * @summary Получен ПДФ отчет для клиента
     * @request GET:/api/contract/v1/external/print/{documentType}/{uuid}
     * @secure
     */
    makeClientReport: (
      documentType: string,
      uuid: string,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/contract/v1/external/print/${documentType}/${uuid}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений
     * @name GetPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/contract/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionListResponse, GenericError>({
        path: `/api/contract/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Download
     * @summary Получение файла
     * @request GET:/api/contract/v1/external/files/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/contract/v1/external/files/${id}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name GetDocuments
     * @summary Получение истории изменений договора ВЭД
     * @request GET:/api/contract/v1/external/documents
     * @secure
     */
    getDocuments: (
      query: { agreementId: string },
      params: RequestParams = {}
    ) =>
      this.request<DocumentListResponse, GenericError>({
        path: `/api/contract/v1/external/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/contract/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (
      query: { documentId: string; documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, GenericError>({
        path: `/api/contract/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/contract/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError>({
        path: `/api/contract/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ЗоСсУ
     * @name GetCloseReasons
     * @summary Получение справочника "Основания для снятия с учёта"
     * @request GET:/api/contract/v1/external/close/reason
     * @secure
     */
    getCloseReasons: (params: RequestParams = {}) =>
      this.request<CloseReasonResponse[], GenericError>({
        path: `/api/contract/v1/external/close/reason`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс управления сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/contract/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, GenericError>({
        path: `/api/contract/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник "Коды оснований для постановки на учет"
     * @name List
     * @summary Получение списка оснований постановки на учет
     * @request GET:/api/contract/v1/external/basis
     * @secure
     */
    list: (params: RequestParams = {}) =>
      this.request<BasisCodesListResponse, GenericError>({
        path: `/api/contract/v1/external/basis`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
